<template>
  <page>
    <div v-if="renderAppType">
      <v-subheader>
        {{labels.appID}}
      </v-subheader>
      <v-container fluid grid-list-lg class="mb-3">
        <v-layout row wrap>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['motorQuotePost'])">
            <v-card :class="isMatchRoute('motorQuotePosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'motorQuotePosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MOTOR}}</v-icon>
                <span>Motor</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['travelQuotePost'])">
            <v-card :class="isMatchRoute('travelQuotePosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'travelQuotePosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.TRAVEL}}</v-icon>
                <span>Travel</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['fireQuotePost'])">
            <v-card :class="isMatchRoute('fireQuotePosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'fireQuotePosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.FIRE}}</v-icon>
                <span>Fire</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['paQuotePost'])">
            <v-card :class="isMatchRoute('paQuotePosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'paQuotePosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PA}}</v-icon>
                <span>Personal Accident</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoQuotePost'])">
            <v-card :class="isMatchRoute('cargoQuotePosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'cargoQuotePosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.CARGO}}</v-icon>
                <span>Cargo</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['maidQuotePost'])">
            <v-card :class="isMatchRoute('maidQuotePosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'maidQuotePosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MAID}}</v-icon>
                <span>Maid</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['packageQuotePost'])">
            <v-card :class="isMatchRoute('packageQuotePosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'packageQuotePosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PACKAGE}}</v-icon>
                <span>Package</span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view ></router-view>
      </transition>
    </div>
    <v-navigation-drawer temporary fixed clipped right app v-model="lifeCycle" width="400">
      <life-cycle query></life-cycle>
    </v-navigation-drawer>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import routeMixin from '@/mixins/route'
import LifeCycle from './LifeCycle'
import { appIcon } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        appID: 'Application Type'
      },
      lifeCycle: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    postingState() {
      return this.$store.state.agency.posting
    },
    renderAppType() {
      if (this.isMatchRouteExact('quotePosting')) {
        return true
      } else {
        return false
      }
    },
    showStatusBtn() {
      // We only want to show at query page
      if (this.isMatchRouteExact('quotePosting') ||
        this.isMatchRouteExact('motorQuotePosting') ||
        this.isMatchRouteExact('fireQuotePosting') ||
        this.isMatchRouteExact('paQuotePosting') ||
        this.isMatchRouteExact('cargoQuotePosting') ||
        this.isMatchRouteExact('travelQuotePosting') ||
        this.isMatchRouteExact('paQuotePosting') ||
        this.isMatchRouteExact('maidQuotePosting') ||
        this.isMatchRouteExact('packageQuotePosting')) {
        return false
      } else {
        return true
      }
    },
    appIcon() {
      return appIcon
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('agencyQuotePostInit')
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    routeMixin
  ],
  components: {
    LifeCycle
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/agency.scss";
</style>
